// Module
var code = "<span> {{ user(value) }} </span> ";
// Exports
module.exports = code;